import indexPage from '../pages/home/index'
import comment from '../pages/comment/list'
import myCombat from '../pages/my/index'
//import combatRank from '../pages/rank/index'
import Rank from '../pages/rank/rank'
import regulation from '../pages/regulation/index'
import Others from '../pages/others/index'
// import passport from './passport/index'
// import course from './course/index'
// import my from './my/index'
// import teacher from './teacher/index'
// import page404 from './error/404'
// import mqtt from '../pages/mqtt/index'

const routes = [
  {
    path: '/combat/',
    name: 'combat',
    component: myCombat,
    props: true,
    meta: {
      title: '我的战绩'
    }
  },
  {
    path: '/others/',
    name: 'others',
    component: Others,
    props: true,
    meta: {
      title: '查看战绩'
    }
  },
  {
    path: '/',
    name: 'index',
    component: indexPage,
    props: true,
    meta: {
      title: '猜涨跌游戏'
    }
  },
  {
    path: '/ranking/',
    name: 'ranking',
    component: Rank,
    props: true,
    meta: {
      title: '战绩排行榜'
    }
  },
  /* {
    path: '/rank/',
    name: 'rank',
    component: combatRank,
    props: true,
    meta: {
      title: '战绩排行榜'
    }
  }, */
  {
    path: '/comment/',
    name: 'comment',
    component: comment,
    props: true,
    meta: {
      title: '股神话大盘'
    }
  },
  {
    path: '/regulation/',
    name: 'regulation',
    component: regulation,
    props: true,
    meta: {
      title: '竞猜规则'
    }
  },
/* 
  {
    name: 'any',
    path: '*',
    redirect(to) {
      const { path, query } = to
      return {
        name: 'page404',
        query: {
          path,
          query: JSON.stringify(query)
        }
      }
    }
  } */
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
  // console.log(route.path);
})

export default routes
